import { useState } from 'react';

const Tabs = ({ tabs, defaultActive = 0, onTabChange }) => {
  const [activeIndex, setActiveIndex] = useState(defaultActive);

  const handleClick = (index) => {
    if (tabs[index]?.disabled) return;
    setActiveIndex(index);
    if (onTabChange) onTabChange(index, tabs[index]);
  };

  return (
    <div className="sub-tabs">
      {tabs.map((tab, index) => (
        <div
          key={index}
          className={`sub-tab${activeIndex === index ? ' active' : ''}${tab.disabled ? ' disabled' : ''}`}
          onClick={() => handleClick(index)}
          title={tab.disabled ? (tab.disabledTitle ?? 'Not available') : undefined}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default Tabs;